import { Typography } from "@mui/material";
import { KeyboardEvent } from "react";
import { DescribedTooltip } from "./DescribedTooltip.tsx";

export const SignaturesTooltip = ({
  numberOfSignatures,
  signatures,
  maxSignaturesInTooltip = 10,
  onClick,
}: {
  numberOfSignatures: number;
  signatures?: Array<{ name: string }>;
  maxSignaturesInTooltip?: number;
  onClick?: () => void;
}) => {
  const count = `{${numberOfSignatures}}`;
  // Keeps the count's look; only adds what keyboard and screen readers need.
  const accessibilityProps = (ariaDescribedById?: string) =>
    onClick
      ? {
          role: "button",
          tabIndex: 0,
          onKeyDown: (event: KeyboardEvent) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClick();
            }
          },
          "aria-describedby": ariaDescribedById,
        }
      : ariaDescribedById
        ? {
            role: "img",
            "aria-label": count,
            tabIndex: 0,
            "aria-describedby": ariaDescribedById,
          }
        : {};
  const countInfo = (ariaDescribedById?: string) => (
    <Typography
      onClick={onClick}
      sx={
        onClick && {
          cursor: "pointer",
          textDecorationLine: "underline",
          textDecorationStyle: "dotted",
        }
      }
      {...accessibilityProps(ariaDescribedById)}
    >
      {count}
    </Typography>
  );

  if (!signatures || signatures.length === 0) return countInfo();

  const tooltipItems =
    signatures.length > maxSignaturesInTooltip
      ? signatures
          .map((x) => x.name)
          .slice(0, maxSignaturesInTooltip - 1)
          .concat("...")
      : signatures.map((x) => x.name);

  return (
    <DescribedTooltip
      title={tooltipItems.join("\n")}
      arrow
      renderTrigger={countInfo}
    />
  );
};
